/**
 * @documental
 * @export Italic
 * @type
 * typographyComponent
 * @use
 * The `Italic` component should be used to identify text content which should be called out for emphasis.
 * @element
 * em
 * @className
 * italic
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { createComponentStyleHook } from "../../tokens";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import tokenStyles from "./styles.module.css";

/**
 * The Italic component properties.
 */

export interface ItalicProps extends BaseProps {}

const useResolvedItalicStyles = createComponentStyleHook<ItalicProps>({
  legacyStyles: () => import("./styles.module.scss"),
  tokenStyles,
  componentTokens: "italic",
});

/**
 * Specifies that text content should be displayed as italic.
 */
export const Italic: FC<PropsWithChildren<ItalicProps>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedItalicStyles(props);
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Italic, "italic"] });

  return (
    <StyleModeBoundary mode={mode}>
      <em {...baseHtmlProps}>{children}</em>
    </StyleModeBoundary>
  );
};
